// components
import type { ISettingPreset } from '@newo/api/gateway';
import SettingsForm from '@/pages/Integrations/components/SettingsForm';
// utils
import { useConnectorSettingsQuery } from '@/services/integration/integration.queries.ts';

interface ConnectorSettingsFormProps {
    connectorId: string;
    presets: ISettingPreset[];
    onSubmit: (values: Record<string, unknown>) => Promise<unknown>;
    onCancel: () => void;
}

const ConnectorSettingsForm = ({
    connectorId,
    presets,
    onCancel,
    onSubmit
}: ConnectorSettingsFormProps) => {
    const { data: connectorSettings = [], isFetching } =
        useConnectorSettingsQuery(connectorId);

    if (isFetching) {
        return;
    }

    return (
        <SettingsForm
            presets={presets}
            settings={connectorSettings}
            onCancel={onCancel}
            onSubmit={onSubmit}
        />
    );
};

export default ConnectorSettingsForm;
